export const useLightboxHotkeys = (goToPrev, goToNext, onCancel, fileCount) => (
    {
        onKeyDown: (keyName, e) => {
            // console.log('aaa onKeyDown', {keyName, e, handle});
            e.preventDefault();
            if (fileCount <= 1) {
                if (keyName === 'esc')
                    onCancel(e, true);
            }
            else {
                switch (keyName) {
                    case 'left':
                        goToPrev();
                        break;
                    case 'right':
                        goToNext();
                        break;
                    case 'esc':
                        onCancel(e, true);
                        break;
                    default:
                        break;
                }
            }
        },
    }
);
